import { type Maybe, type ReleaseDates } from '@tmdb-graphql-api/schema/types';
import { type BbfcCertification } from '../enums/certifications.ts';

export const getMovieCertFromReleaseDates = (releaseDates: Maybe<ReleaseDates>[] = [], country: string) =>
  releaseDates.reduce<BbfcCertification | undefined>((cert, releaseDate) => {
    const isBbfcCertification = (_cert: string): _cert is BbfcCertification => releaseDate?.iso_3166_1 === country;
    const { certification } = releaseDate?.releaseDates[0] ?? {};

    if (certification && isBbfcCertification(certification)) {
      return certification;
    }

    return cert;
    // eslint-disable-next-line unicorn/no-useless-undefined
  }, undefined);
